<template>
    <input
        type="checkbox"
        :value="value"
        :disabled="disabled"
        v-model="proxyChecked"
        :class="checkboxClasses"
    />
</template>

<script>
export default {
    emits: ["update:checked"],

    props: {
        checked: {
            type: [Array, Boolean],
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        value: {
            default: null,
        },
    },

    computed: {
        proxyChecked: {
            get() {
                return this.checked;
            },

            set(val) {
                this.$emit("update:checked", val);
            },
        },
        checkboxClasses() {
            let result = ["rounded", "mr-2"];
            if (this.disabled) {
                result.push("cursor-not-allowed");
                result.push("text-gray-400");
            } else {
                result.push("text-primary");
                result.push("cursor-pointer");
                result.push("hover:text-primary");
                result.push("hover:border-primary");
                result.push("focus:ring-0");
            }
            return result;
        },
    },
};
</script>
